import { Component, Input } from '@angular/core';
import { AvatarDirective } from './avatar.directive';

@Component({
  selector: 'lc-avatar',
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.scss'],
  imports: [AvatarDirective],
})
export class AvatarComponent {
  @Input() size: number = 40;
  @Input() isVip = false;
  @Input({ required: true }) photoUrl!: string;
}
